// extracted by mini-css-extract-plugin
export default {"image":"Recipes_image__cDHrD","title":"Recipes_title__ePbXn","dark":"Recipes_dark__FB2S5"};